import { RepairOrderQuoteStatusEnum } from 'api-new/generated';
import { EnumOptions } from 'ts-types';
import { fromEnum } from 'utils/enums';
import { splitPascalCase } from 'utils/strings';

export const RepairOrderQuoteStatusEnumValues: EnumOptions<typeof RepairOrderQuoteStatusEnum, string>[] = fromEnum(
  RepairOrderQuoteStatusEnum,
  ([label, value]: [keyof typeof RepairOrderQuoteStatusEnum, RepairOrderQuoteStatusEnum]) => {
    const fixLabel = value != RepairOrderQuoteStatusEnum.Deffered ? splitPascalCase(label) : 'Deferred';
    return {
      label: fixLabel,
      value
    };
  }
);
